function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.222 9.75c-1.396.51-2.28 1.82-2.179 3.255l.034.553-.56-.067c-2.033-.26-3.81-1.141-5.319-2.622l-.737-.734-.19.542c-.402 1.21-.145 2.486.693 3.345.447.475.346.542-.425.26-.268-.09-.503-.158-.525-.125-.078.08.19 1.108.402 1.514.29.566.883 1.12 1.531 1.447l.548.26-.648.01c-.626 0-.648.012-.58.25.223.734 1.105 1.513 2.089 1.853l.693.236-.604.362a6.286 6.286 0 0 1-2.995.836c-.503.012-.917.057-.917.09 0 .114 1.364.746 2.157.995 2.38.734 5.208.418 7.331-.836 1.51-.893 3.017-2.667 3.722-4.384.38-.915.76-2.588.76-3.39 0-.52.034-.587.66-1.209.368-.362.714-.756.782-.87.112-.214.1-.214-.47-.023-.95.34-1.084.295-.614-.214.346-.361.76-1.017.76-1.21 0-.032-.168.023-.358.125-.201.113-.648.283-.984.384l-.603.192-.547-.373c-.302-.203-.726-.43-.95-.497-.57-.157-1.442-.135-1.957.046zM0 0h32v32H0V0z",
  fill: "#B2B2B2",
  fillRule: "evenodd"
});

var SvgIcnTwitter = function SvgIcnTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn-twitter.cf9ea5d5.svg";
export { ForwardRef as ReactComponent };